﻿// TODO: Remove after migration
$extend("Cognito.Forms.FormEntry", function (entry) {
	entry.meta.addProperty({ name: "Require_Payment", type: Boolean }).defaultValue(true);
});

Cognito.Messaging.addHandler("submitEntryPayment", function (data) {
	var viewId = Cognito.Forms.model.viewId;
	if (data.paymentMethod.toLowerCase() == "credit card on file") {

		var customerCard = new Cognito.Payment.CustomerCard({ CustomerId: Cognito.Forms.model.entry.get_Entry().get_CustomerCard().get_CustomerId(), CustomerCardId: data.customerCardId });
		Cognito.Forms.makePayment(viewId, Cognito.Forms.model.entry.get_Id(), null, customerCard, Cognito.Forms.model.order.get_OrderAmount(), function (data) {
			if (data.submissionResult.Status !== "Success") {
				if (data.supportPageLinkUrl) {
					Cognito.Forms.formsPaymentError(data.exceptionMessage + "<br><a href='" + data.supportPageLinkUrl + "' target='_blank'>" + (data.supportPageLinkText || "Learn how to fix this.") + "</a>");
				} else {
					Cognito.Forms.formsPaymentError(data.exceptionMessage);
				}
			}
			else if (data.order) {
				if (data.order.PaymentStatus == "Paid") {
					ExoJQuery(".c-forms-payment-dialog").hide();
					ExoJQuery(".c-forms-payment-dialog-result").show();
				} else {
					Cognito.Forms.formsPaymentError(data.order.PaymentStatus + ": " + data.order.PaymentMessage);
				}
			}
			Cognito.Messaging.trigger("entryPaymentComplete", { origin: Cognito.config.baseUrl, data: data });
		}, function () {
			Cognito.Forms.formsPaymentError(Cognito.resources["payment-declined"] + ": " + Cognito.resources["order-exception-default-message"]);
			Cognito.Messaging.trigger("entryPaymentComplete", { origin: Cognito.config.baseUrl, data: { order: null } });
		});
	}
	else if (data.paymentMethod.toLowerCase() == "mark as paid") {
		Cognito.Forms.makePayment(viewId, Cognito.Forms.model.entry.get_Id(), null, null, Cognito.Forms.model.order.get_OrderAmount(), function (data) {
			ExoJQuery(".c-forms-payment-dialog").hide();
			ExoJQuery(".c-forms-payment-dialog-result").show();
			Cognito.Messaging.trigger("entryPaymentComplete", { origin: Cognito.config.baseUrl, data: data });
		});
	}
	else {
		Cognito.Forms.submitPayment(Cognito.Forms.model.entry, Cognito.Forms.model.order, function (entry) {
			Cognito.Forms.makePayment(viewId, entry.get_Id(), entry.get_Entry().get_PaymentToken(), null, Cognito.Forms.model.order.get_OrderAmount(), function (data) {
				if (data.submissionResult.Status !== "Success") {
					if (data.supportPageLinkUrl) {
						Cognito.Forms.formsPaymentError(data.exceptionMessage + "<br><a href='" + data.supportPageLinkUrl + "' target='_blank'>" + (data.supportPageLinkText || "Learn how to fix this.") + "</a>");
					} else {
						Cognito.Forms.formsPaymentError(data.exceptionMessage);
					}
				}
				else if (data.order) {
					if (data.order.PaymentStatus == "Paid") {
						ExoJQuery(".c-forms-payment-dialog").hide();
						ExoJQuery(".c-forms-payment-dialog-result").show();
					} else {
						Cognito.Forms.formsPaymentError(data.order.PaymentStatus + ": " + data.order.PaymentMessage);
					}
				}
				Cognito.Messaging.trigger("entryPaymentComplete", { origin: Cognito.config.baseUrl, data: data });
			}, function () {
				Cognito.Forms.formsPaymentError(Cognito.resources["payment-declined"] + ": " + Cognito.resources["order-exception-default-message"]);
				Cognito.Messaging.trigger("entryPaymentComplete", { origin: Cognito.config.baseUrl, data: { order: null } });
			});
		}, function (paymentResponseMessage) {
			Cognito.Forms.formsPaymentError(paymentResponseMessage.errorMessage);
			Cognito.Messaging.trigger("entryPaymentComplete", { origin: Cognito.config.baseUrl, data: { order: null } });
		})
	}
});

Cognito.Messaging.addHandler("clearEntryPaymentResult", function () {
	ExoJQuery(".c-forms-payment-dialog-result").hide();
});